import React, { Component } from 'react';
import request from 'utils/request_ajax';
import { Icon } from 'ui';

class EmailInstructions extends Component {
  constructor(props) {
    super(props);
    this.state = { done: false };
  }

  sendEmailInstructions = () => {
    const { user } = this.props;
    request.postJSON(`/users/${user.id}/resend_password_email`).then(() => {
      this.setState({ done: true });
    });
  };

  render() {
    if (this.state.done) {
      return (
        <div>
          <p className="c-green">
            <Icon name="saved" /> {t('common.success')}!
          </p>
          <p>
            {this.props.user.passwordless
              ? t('users.reset_password.welcome_email.sent')
              : t('users.reset_password.reset_email.sent')}
          </p>
        </div>
      );
    }

    return (
      <div>
        <p className="fz-16 mb-16">
          {this.props.canResetPassword
            ? t('users.reset_password.description_and_create')
            : t('users.reset_password.description')}
        </p>

        <button
          type="button"
          onClick={this.sendEmailInstructions}
          className="NewButton NewButton--fw NewButton--center NewButton--tall CustomColor--backgroundColor CustomColor--buttonBoxShadow NewButton--lessonlyBrandColor"
        >
          {this.props.user.passwordless
            ? t('users.notifications.welcome.button')
            : t('users.reset_password.email_instructions')}
        </button>
      </div>
    );
  }
}

export default EmailInstructions;
